import { Injectable } from "@angular/core";
import { AuthSelectors } from "@app/store/auth/auth.selectors";
import { Store } from "@ngxs/store";

interface Objcd {
    corpcd: string;
    officecd: string;
    blockcd: string;
    subcd: string;
    unitcd: string;
}

@Injectable({
    providedIn: 'root'
})
export class OfficeService {

    get officecd() {
        return localStorage.getItem('objectcd') || this.store.selectSnapshot(AuthSelectors.objectcd) || '';
    }

    get officecdAbsolute() {
        const corpcd = this.officecd.slice(0,1);
        const officecd = this.officecd.slice(1,3);
        return `${corpcd}${officecd}0000000`;
    }

    constructor(private store: Store) { }
    getObjcd({ corpcd, officecd, blockcd, subcd, unitcd }: Objcd) {
        return `${corpcd}${officecd}${blockcd}${subcd}${unitcd}`;
    }

}